export function isFavoriteRecipe(recipeId, favorites) {
  const favoriteMains = favorites.mains.filter( main => (main.id === recipeId));
  const favoriteSides = favorites.sides.filter( side => (side.id === recipeId));

  return (favoriteMains.length > 0) || (favoriteSides.length > 0);
}